module.exports = __webpack_public_path__ + "static/mixit2019-af2e8ede75e69b79e17edb752f4ca27e.png";